import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ASSET_PATHS } from '@app/constants/asset-paths';

export interface BuyerGuideStep {
  id: number;
  shortTitle: string;
  title: string;
  description: string;
  image: string;
  alt: string;
}

@Component({
  standalone: true,
  imports: [NgOptimizedImage],
  selector: 'app-buy-guide-card',
  templateUrl: './buy-guide-card.component.html',
  styleUrls: ['./buy-guide-card.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuyGuideCardComponent {
  readonly steps: BuyerGuideStep[] = [
    {
      id: 1,
      shortTitle: 'Agent',
      title: 'Pick a Gabali Realty Agent',
      description:
        'A great agent advocates for you from day one. Our Laredo team knows the neighborhoods, pricing trends, and negotiation strategies that turn a stressful search into a confident purchase.',
      image: ASSET_PATHS.guides.buyer.agents,
      alt: 'Choose a Gabali Realty agent',
    },
    {
      id: 2,
      shortTitle: 'Pre-Qualify',
      title: 'Get Pre-Qualified',
      description:
        'Pre-qualification clarifies your budget before you fall in love with a listing. Lenders review income, credit, and debts to estimate what you can borrow — with no obligation to move forward.',
      image: ASSET_PATHS.guides.buyer.getPrequalified,
      alt: 'Get pre-qualified for a mortgage',
    },
    {
      id: 3,
      shortTitle: 'Lender',
      title: 'Choose the Right Mortgage Lender',
      description:
        'Not all lenders offer the same programs or rates. A mortgage broker can shop multiple institutions to find terms that fit your situation — especially helpful for first-time buyers and self-employed borrowers.',
      image: ASSET_PATHS.guides.buyer.chooseMortgageLender,
      alt: 'Choose a mortgage lender',
    },
    {
      id: 4,
      shortTitle: 'Search',
      title: 'Search, Tour & Make an Offer',
      description:
        'Use our map search to narrow by area, then tour the homes that fit. When you find the right one, your agent runs a market analysis so your offer is competitive without overpaying.',
      image: ASSET_PATHS.guides.buyer.searchForHomes,
      alt: 'Search for homes',
    },
    {
      id: 5,
      shortTitle: 'Close',
      title: 'Close on Your Home',
      description:
        'In escrow, your agent tracks deadlines, inspections, and lender requirements through closing day. Most Texas purchases take 30–45 days from accepted offer to keys in hand.',
      image: ASSET_PATHS.guides.buyer.closeOnHome,
      alt: 'Close on your home',
    },
  ];

  readonly activeStep = signal(1);

  selectStep(stepId: number): void {
    this.activeStep.set(stepId);
  }
}
